import { ElementNode, $applyNodeReplacement } from 'lexical';
import './scss/ChecklistItem.scss';

export class ChecklistItemNode extends ElementNode {
  __checked;

  static getType() {
    return 'checklist-item';
  }

  static clone(node) {
    return new ChecklistItemNode(node.__checked, node.__key);
  }

  constructor(checked = false, key) {
    super(key);
    this.__checked = checked;
  }

  createDOM(config) {
    const dom = document.createElement('div');
    dom.className = 'checklist-item';
    if (this.__checked) {
      dom.classList.add('checked');
    }
    return dom;
  }

  updateDOM(prevNode, dom) {
    if (prevNode.__checked !== this.__checked) {
      if (this.__checked) {
        dom.classList.add('checked');
      } else {
        dom.classList.remove('checked');
      }
    }
    return false;
  }

  static importJSON(serializedNode) {
    const node = $createChecklistItemNode(serializedNode.checked);
    node.setFormat(serializedNode.format);
    node.setIndent(serializedNode.indent);
    node.setDirection(serializedNode.direction);
    return node;
  }

  exportJSON() {
    return {
      ...super.exportJSON(),
      checked: this.__checked,
      type: 'checklist-item',
      version: 1,
    };
  }

  getChecked() {
    return this.__checked;
  }

  setChecked(checked) {
    const writable = this.getWritable();
    writable.__checked = checked;
  }

  toggleChecked() {
    const writable = this.getWritable();
    writable.__checked = !writable.__checked;
  }

  canBeEmpty() {
    return true;
  }

  isInline() {
    return false;
  }
}

export function $createChecklistItemNode(checked = false) {
  return $applyNodeReplacement(new ChecklistItemNode(checked));
}

export function $isChecklistItemNode(node) {
  return node instanceof ChecklistItemNode;
}

